import styles from './warningMessage.module.scss';
import { ReactComponent as InfoIcon } from 'icons/info.svg';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'store/actions';
import { useTranslation } from 'react-i18next';

export default function WarningMessage() {
  const dispatch = useDispatch();
  const showWarning = useSelector((state) => state.warning.showWarning);
  const { t } = useTranslation();

  const onClick = (event, reason) => {
    if ((reason && reason === 'backdropClick') || reason === 'escapeKeyDown') return;
    dispatch(actions.warning.setShowWarning(false));
  };

  return (
    <Modal open={showWarning} onClose={onClick}>
      <div className={styles.warning_modal}>
        <InfoIcon />
        <h3>{t('warningMessage.title')}</h3>
        <p>{t('warningMessage.description')}</p>
        <Button
          data-testid="WarningMessageCloseButton"
          className={styles.warning_modal__button}
          onClick={onClick}
          size="small"
          variant="contained">
          {t('warningMessage.dismiss')}
        </Button>
      </div>
    </Modal>
  );
}
